import React, {useState, useRef, useEffect} from 'react';
import UserListItem from "./UserListItem.mjs";
import UserListItemMessage from "./UserListItemMessage.mjs";
import { useCTAL } from './CTAL_Hooks.js';

export default function UserShortList({user_id}) 
{
    const { user_short_list, setUserShortList, action_item_short_list_count_refresh, setActionItemShortListCountRefresh } = useCTAL();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();

    //Note: Reloading only for AI Counter Refresh
    useEffect(() =>
    {
        if (!user_id) return;
        
        if (!action_item_short_list_count_refresh) return;

        setActionItemShortListCountRefresh(false);

        var type = "get_user_list";
        var search_body = JSON.stringify({type, user_id});      
    
        console.log(`UserShortList - fetching User List from ctal-get for: ${user_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(setUserShortList)
            .then(() => setLoading(false))
            .catch(setError);
    }, [action_item_short_list_count_refresh]);

    if (loading) return <UserListItemMessage message="Loading User List..." />;
    if (error) return <UserListItemMessage message={JSON.stringify(error, null, 2)} /> 
    
    if (!user_short_list) return;

    return (
        <>
            <UserListItem list={user_short_list} display_type="user-short-list-display" />
        </>
    );
}